import { createI18n } from 'vue-i18n'
import en from './locales/en'
import ru from './locales/ru'

// Get saved language from localStorage or default to 'en'
const savedLocale = localStorage.getItem('locale') || 'en'

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
  },
})

export default i18n

